import { Control, FieldValues, Path, useController } from 'react-hook-form';
import Input, { InputProps } from '../ui/Input';

interface InputFieldProps<T extends FieldValues> extends InputProps {
  control: Control<T>;
  name: Path<T>;
}

function InputField<T extends FieldValues>({
  control,
  name,
  isDisabled,
  ...props
}: InputFieldProps<T>) {
  const {
    field,
    fieldState: { error, invalid },
    formState: { isSubmitting },
  } = useController({
    name,
    control,
  });

  return (
    <Input
      {...props}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      errorMessage={error?.message}
      isDisabled={isDisabled}
      isReadOnly={isSubmitting}
      isInvalid={invalid}
      validationBehavior="aria"
    />
  );
}

export default InputField;
